import { Link } from "react-router-dom";
import StatusBadge from "@/components/feature/StatusBadge";
import { eventList } from "@/mocks/events";
import { formatDate, getCategoryName } from "@/lib/eventUtils";

export default function TrackingNow() {
  const featured =
    [...eventList].sort((a, b) => b.heat - a.heat).find((item) => item.status === "ongoing") ??
    eventList[0];
  const latestNode = featured.timeline[featured.timeline.length - 1];

  return (
    <section className="w-full px-5 md:px-10 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
        <div className="lg:w-[62%]">
          <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.22em] text-primary-600 font-medium">
            <span className="w-5 h-px bg-primary-400" />
            正在追踪
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            热度最高的一起事件，现在进行到哪一步了
          </h2>

          <div className="mt-6 rounded-lg overflow-hidden border border-background-200 bg-background-100">
            <div className="w-full h-52 md:h-72 overflow-hidden">
              <img
                src={featured.cover}
                alt={`${featured.title}事件封面插图`}
                title={`${featured.title} - 事件进展与真相梳理`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-3">
                <StatusBadge status={featured.status} size="md" />
                <span className="text-xs text-foreground-600">
                  {getCategoryName(featured.category)} · {featured.region}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-lg md:text-2xl font-bold text-foreground-950 leading-snug">
                <Link to={`/events/${featured.id}`} className="hover:text-primary-700 transition-colors cursor-pointer">
                  {featured.title}
                </Link>
              </h3>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
                {featured.summary}
              </p>
              <div className="mt-5 pt-5 border-t border-background-200 flex flex-wrap items-center justify-between gap-3">
                <p className="text-xs text-foreground-500">
                  最近更新：{formatDate(featured.updatedAt)} · 共 {featured.timeline.length} 个节点
                </p>
                <Link
                  to={`/events/${featured.id}`}
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-600 whitespace-nowrap cursor-pointer"
                >
                  查看完整时间线
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <aside className="lg:w-[38%] flex flex-col gap-5">
          <div className="rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
            <h3 className="font-heading text-base font-bold text-primary-900 flex items-center gap-2">
              <i className="ri-flashlight-line" />
              最新节点
            </h3>
            <p className="mt-3 font-heading text-sm font-bold text-foreground-950">{latestNode.title}</p>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">{latestNode.desc}</p>
            <p className="mt-3 text-xs text-primary-700">{formatDate(latestNode.date)} · {latestNode.type}</p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
              <i className="ri-file-list-3-line text-accent-600" />
              为什么要看时间线
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700 leading-relaxed">
              <li className="flex gap-2.5">
                <i className="ri-checkbox-circle-line text-accent-600 mt-0.5" />
                同一条消息，不同时间点的说法可能完全不同。
              </li>
              <li className="flex gap-2.5">
                <i className="ri-checkbox-circle-line text-accent-600 mt-0.5" />
                按时间排列后，谁先提出、谁后回应，脉络自然清晰。
              </li>
              <li className="flex gap-2.5">
                <i className="ri-checkbox-circle-line text-accent-600 mt-0.5" />
                出现反转时，原节点会被保留并标注更正，不会凭空消失。
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}